/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingframinglabel2Inputs */

const en_crosspostingframinglabel2 = /** @type {(inputs: Crosspostingframinglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move the visible section`)
};

const de_crosspostingframinglabel2 = /** @type {(inputs: Crosspostingframinglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildausschnitt verschieben`)
};

/**
* | output |
* | --- |
* | "Move the visible section" |
*
* @param {Crosspostingframinglabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingframinglabel2 = /** @type {((inputs?: Crosspostingframinglabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingframinglabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingframinglabel2(inputs)
	return de_crosspostingframinglabel2(inputs)
});
export { crosspostingframinglabel2 as "crosspostingFramingLabel" }